module.exports = __webpack_public_path__ + "static/img/img_tool@2x.c3b0c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_tool@2x.png
// module id = wyOx
// module chunks = 0